import { render, staticRenderFns } from "./FirstLogin.vue?vue&type=template&id=67e6611c&scoped=true"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6611c",
  null
  
)

export default component.exports